document.querySelector('.mobile-header__open-menu').addEventListener('click', function() {
//   document.querySelector('.mobile-header__menu').classList.toggle('mobile-header__menu--open');
  Shopify.theme.mobileMenu.open()
});

document.querySelector('.mobile-header__close-menu').addEventListener('click', function() {
  // document.querySelector('.mobile-header__close-menu').classList.toggle('mobile-header__menu--open');
  Shopify.theme.mobileMenu.close()
});


document.querySelectorAll('.product-image__wrapper').forEach(itm => {
  if (window.innerWidth < 768) {
    if(itm){
      itm.addEventListener('click', function(e) { 
        // e.preventDefault();
        console.log(e.target)
        const overlayContainer = e.target.closest('.thumbnail-overlay__container')
        overlayContainer.classList.toggle('active');
        const productLink = overlayContainer.querySelector('.hidden-product-link').getAttribute("href")
        console.log(productLink)
        window.location.href = productLink; //this is the url where the anchor tag points to.
        if(e.target.tagName.toLowerCase() === 'a'){
            window.location.href = e.target.href; //this is the url where the anchor tag points to.
        }
      })
    }
  }
})